import dynamic from "next/dynamic";
import { ArticleSection as UIArticleSection } from "@business-finland/wif-ui-lib/dist/ArticleSection";

const HtmlParser = dynamic(() => import("../../../components/HtmlParser"));

interface IArticleSectionProps {
  heading?: string;
  anchorTag?: string;
  subHeading?: string;
  bodyText: string;
}

export function ArticleSection({
  heading,
  anchorTag,
  subHeading,
  bodyText,
}: IArticleSectionProps): JSX.Element {
  return (
    <UIArticleSection
      heading={heading}
      id={anchorTag}
      subHeading={subHeading}
      bodyText={<HtmlParser html={bodyText} />}
    />
  );
}
